"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCapaddress = void 0;

var react_1 = require("react");

var fetch_jsonp_1 = __importDefault(require("fetch-jsonp"));

var request_1 = require("../../services/request");

function useCapaddress(type, inputOutput, address) {
  var _this = this;

  var _a = __read(react_1.useState([]), 2),
      zipCodeList = _a[0],
      setZipCodeList = _a[1];

  var _b = __read(react_1.useState([]), 2),
      addressList = _b[0],
      setAddressList = _b[1];

  var endpoint = "https://ws.capadresse.com:2814/?";

  var searchAddress = function searchAddress() {
    var data = {
      request: "SearchAddress",
      inputOutput: inputOutput,
      step: "SearchLocality",
      countryCode: "FRA",
      languageCode: "fr",
      jsoncallback: "SearchAddress"
    };
    wrapperRequest(data, setZipCodeList);
  };

  var searchStreet = function searchStreet() {
    var locality = address.locality,
        localityId = address.localityId,
        postalCode = address.postalCode;
    var data = {
      request: "SearchAddress",
      inputOutput: inputOutput,
      step: "SearchStreet",
      countryCode: "FRA",
      languageCode: "fr",
      qualityCode: 42,
      localityId: localityId,
      postalCode: postalCode,
      locality: locality,
      jsoncallback: "SearchAddress"
    };
    wrapperRequest(data, setAddressList);
  };

  var wrapperRequest = function wrapperRequest(data, callback) {
    return __awaiter(_this, void 0, void 0, function () {
      var url, request, addresses, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            url = endpoint + request_1.parseData(data);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 4,, 5]);

            return [4, fetch_jsonp_1.default(url, {
              jsonpCallbackFunction: "SearchAddress"
            })];

          case 2:
            request = _a.sent();
            return [4, request.json()];

          case 3:
            addresses = _a.sent().addresses;
            callback(addresses.address);
            return [3, 5];

          case 4:
            e_1 = _a.sent();
            return [2, e_1];

          case 5:
            return [2];
        }
      });
    });
  };

  react_1.useEffect(function () {
    if (type === "street" && address) searchStreet();else if (type === "town") searchAddress();
  }, [inputOutput, type]);
  return type === "town" ? zipCodeList : addressList;
}

exports.useCapaddress = useCapaddress;